import axios from "axios";
import { authHeaders } from "./authRefresh";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/parasut`;
const cfg = (extra = {}) => ({ headers: authHeaders(), ...extra });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return e?.message || "İşlem başarısız";
};

let statusCache = null;
export const parasutApi = {
  status: () => {
    if (!statusCache || Date.now() - statusCache.t > 300000) {
      statusCache = { t: Date.now(), p: axios.get(`${BASE}/status`, cfg()).then((r) => r.data) };
      statusCache.p.catch(() => { statusCache = null; });
    }
    return statusCache.p;
  },
  rates: () => axios.get(`${BASE}/rates`, cfg()).then((r) => r.data),
  rules: () => axios.get(`${BASE}/rules`, cfg()).then((r) => r.data),
  saveRules: (body) => axios.put(`${BASE}/rules`, body, cfg()).then((r) => r.data),
  prefill: (bookingId) => axios.get(`${BASE}/prefill/${bookingId}`, cfg()).then((r) => r.data),
  list: (params) => axios.get(`${BASE}/invoices`, cfg({ params })).then((r) => r.data),
  billable: (date) => axios.get(`${BASE}/billable`, cfg({ params: { date } })).then((r) => r.data),
  create: (body) => axios.post(`${BASE}/invoices`, body, cfg()).then((r) => r.data),
  update: (id, body) => axios.put(`${BASE}/invoices/${id}`, body, cfg()).then((r) => r.data),
  formalize: (id) => axios.post(`${BASE}/invoices/${id}/formalize`, {}, cfg()).then((r) => r.data),
  refresh: (id) => axios.get(`${BASE}/invoices/${id}/refresh`, cfg()).then((r) => r.data),
  cancel: (id) => axios.post(`${BASE}/invoices/${id}/cancel`, {}, cfg()).then((r) => r.data),
  pdf: (id) => axios.get(`${BASE}/invoices/${id}/pdf`, cfg({ responseType: "blob", validateStatus: (s) => s < 300 })),
};

export async function openInvoicePdf(id) {
  const r = await parasutApi.pdf(id);
  if (r.status === 202) return false;
  const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
}
